import $ from 'cash-dom';
import lottie from 'lottie-web';

export default () => {
  const $aero = $('.js-aero-animate');

  if ($aero.length) {
    const headerHeight = $('.header').height();
    const menuHeight = $('.scroll-menu').height() || 0;
    const url = window.script_data !== undefined
      ? `${window.script_data.urlTheme}/assets/other/`
      : './other/';

    const aeroAnimate = () => {
      const aeroTop = $aero.offset().top;
      const aeroHeight = $aero.height();
      const aeroDistanceForAnimation = aeroTop + aeroHeight / 4;
      const scrollTop = window.pageYOffset + headerHeight + menuHeight;

      if (scrollTop >= aeroTop
        && scrollTop <= aeroDistanceForAnimation
        && !$aero.hasClass('is-active')) {
        $aero.addClass('is-active');

        setTimeout(() => {
          lottie.loadAnimation({
            container: $aero.find('.js-aero-lines')[0], // the dom element that will contain the animation
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: `${url}lines.json`, // the path to the animation json
          });
        }, 500);
      }
    };

    aeroAnimate();

    $(window).on('scroll', () => {
      aeroAnimate();
    });
  }
};
